// Vehicle catalog seed for the customer/vehicle forms (Feb/2026).
//
// Used by the Combobox suggestions in `Customers.jsx` (create modal +
// inline edit). The list is intentionally NOT exhaustive — it covers the
// 90% case (top-of-mind brands and models in the Brazilian market). The
// Combobox always allows free-typing for the long tail, so missing
// entries here aren't a blocker.
//
// Models are keyed by brand (uppercase exact match against the user's
// input). When we can't find a match for the brand, we fall back to a
// universal generic list so the operator still gets help.

export const CAR_BRANDS = [
  "BYD", "Chevrolet", "Citroën", "Fiat", "Ford", "Honda", "Hyundai",
  "Jeep", "Kia", "Land Rover", "Mercedes-Benz", "Mitsubishi", "Nissan",
  "Peugeot", "Renault", "Suzuki", "Toyota", "Volkswagen", "Volvo",
  "Audi", "BMW", "Caoa Chery", "GWM", "JAC", "Mini", "Porsche", "RAM",
  "Subaru", "Tesla", "Lexus", "Outras",
];

export const VEHICLE_MODELS_BY_BRAND = {
  BYD: ["Song Pro", "Yuan Plus", "Dolphin", "Han", "Seal", "King", "Tang"],
  Chevrolet: ["Onix", "Onix Plus", "Tracker", "S10", "Cruze", "Spin", "Equinox", "Montana", "Trailblazer"],
  "Citroën": ["C3", "C4 Cactus", "Aircross", "Berlingo"],
  Fiat: ["Argo", "Cronos", "Mobi", "Pulse", "Toro", "Strada", "Fastback", "Fiorino", "Doblò"],
  Ford: ["Ka", "EcoSport", "Ranger", "Bronco", "Mustang", "Maverick", "Territory"],
  Honda: ["Civic", "City", "Fit", "HR-V", "WR-V", "CR-V", "ZR-V"],
  Hyundai: ["HB20", "HB20S", "Creta", "Tucson", "Santa Fe", "Kona", "i30"],
  Jeep: ["Renegade", "Compass", "Commander", "Wrangler", "Grand Cherokee", "Gladiator"],
  Kia: ["Picanto", "Stonic", "Cerato", "Sportage", "Sorento", "Seltos"],
  "Land Rover": ["Discovery", "Discovery Sport", "Range Rover", "Range Rover Sport", "Range Rover Evoque", "Defender"],
  "Mercedes-Benz": ["Classe A", "Classe C", "Classe E", "GLA", "GLC", "GLE", "Classe S"],
  Mitsubishi: ["L200", "Outlander", "ASX", "Pajero", "Eclipse Cross"],
  Nissan: ["Kicks", "Versa", "Frontier", "Sentra", "X-Trail", "Leaf"],
  Peugeot: ["208", "2008", "3008", "5008", "Partner"],
  Renault: ["Kwid", "Sandero", "Logan", "Duster", "Captur", "Oroch", "Kardian", "Kangoo"],
  Suzuki: ["Jimny", "Vitara", "S-Cross"],
  Toyota: ["Corolla", "Corolla Cross", "Yaris", "Hilux", "SW4", "Rav4", "Camry", "Etios"],
  Volkswagen: ["Polo", "Virtus", "T-Cross", "Nivus", "Taos", "Saveiro", "Amarok", "Tiguan", "Jetta", "Voyage", "Gol", "Fox"],
  Volvo: ["XC40", "XC60", "XC90", "S60", "S90"],
  Audi: ["A3", "A4", "A5", "Q3", "Q5", "Q7", "Q8", "e-tron"],
  BMW: ["Série 1", "Série 3", "Série 5", "X1", "X3", "X5", "X6", "iX"],
  "Caoa Chery": ["Tiggo 2", "Tiggo 3X", "Tiggo 5X", "Tiggo 7", "Tiggo 8", "Arrizo 5"],
  GWM: ["Haval H6", "Ora 03", "Tank 300"],
  JAC: ["E-JS1", "T8 Pro", "iEV40"],
  Mini: ["Cooper", "Countryman", "Clubman"],
  Porsche: ["911", "Cayenne", "Macan", "Panamera", "Taycan"],
  RAM: ["1500", "2500", "Rampage"],
  Subaru: ["Forester", "Outback", "WRX", "XV"],
  Tesla: ["Model 3", "Model Y", "Model S", "Model X"],
  Lexus: ["NX", "RX", "UX", "ES"],
};

export const VEHICLE_COLORS = [
  "Preto", "Branco", "Prata", "Cinza", "Grafite", "Chumbo",
  "Vermelho", "Vinho", "Azul", "Azul Marinho", "Bege", "Marrom",
  "Verde", "Verde Musgo", "Amarelo", "Laranja", "Dourado", "Bronze",
  "Champagne", "Outras",
];

/**
 * Resolve the model list for a given brand. Matches case-insensitively
 * against `VEHICLE_MODELS_BY_BRAND`; falls back to an empty array so
 * the Combobox just shows whatever the operator types.
 */
export function modelsForBrand(brand) {
  if (!brand) return [];
  const target = String(brand).trim().toLowerCase();
  const match = Object.keys(VEHICLE_MODELS_BY_BRAND).find(
    (k) => k.toLowerCase() === target,
  );
  return match ? VEHICLE_MODELS_BY_BRAND[match] : [];
}
